import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-worklog-deletion-progress-dialog',
  templateUrl: './worklog-deletion-progress-dialog.component.html',
  styleUrls: ['./worklog-deletion-progress-dialog.component.scss']
})
export class WorklogDeletionProgressDialogComponent {
  progressValue = 0;
  currentActivity = '';
  completedCount = 0;
  totalCount = 0;
  isComplete = false;
  isCancelled = false;
  successCount = 0;
  failureCount = 0;

  constructor(
    public dialogRef: MatDialogRef<WorklogDeletionProgressDialogComponent>
  ) {
    // Disable close on backdrop click during deletion
    this.dialogRef.disableClose = true;
  }

  updateProgress(completed: number, total: number, activityText: string): void {
    this.completedCount = completed;
    this.totalCount = total;
    this.currentActivity = activityText;
    this.progressValue = (completed / total) * 100;
  }

  setComplete(successCount: number, failureCount: number): void {
    this.isComplete = true;
    this.successCount = successCount;
    this.failureCount = failureCount;
    this.progressValue = 100;
    // Allow close on backdrop click when complete
    this.dialogRef.disableClose = false;
  }

  onCancel(): void {
    this.isCancelled = true;
    this.dialogRef.close('cancelled');
  }

  onClose(): void {
    this.dialogRef.close('complete');
  }
}
